export default __webpack_public_path__ + "static/media/cloud2.23ec6507.svg";